export function buildTransactionId(): string {
  const webCrypto = globalThis.crypto;
  if (typeof webCrypto?.randomUUID === "function") {
    return webCrypto.randomUUID();
  }

  if (typeof webCrypto?.getRandomValues === "function") {
    const bytes = new Uint32Array(1);
    webCrypto.getRandomValues(bytes);
    return `txn-${Date.now()}-${bytes[0].toString(16)}`;
  }

  return `txn-${Date.now()}`;
}
